import { NavLink } from "react-router-dom";

export default function AdminNav() {
  return (
    <nav className="mp-admin-nav" aria-label="Admin">
      <NavLink to="/admin" end className={({ isActive }) => (isActive ? "is-active" : undefined)}>
        Users
      </NavLink>
      <NavLink
        to="/admin/email-previews"
        className={({ isActive }) => (isActive ? "is-active" : undefined)}
      >
        Email Previews
      </NavLink>
      <NavLink
        to="/admin/crm-backfill"
        className={({ isActive }) => (isActive ? "is-active" : undefined)}
      >
        CRM Backfill
      </NavLink>
      <NavLink
        to="/admin/manual-access"
        className={({ isActive }) => (isActive ? "is-active" : undefined)}
      >
        Manual Access
      </NavLink>
      <NavLink
        to="/admin/lifecycle-dry-run"
        className={({ isActive }) => (isActive ? "is-active" : undefined)}
      >
        Lifecycle Dry Run
      </NavLink>
    </nav>
  );
}
